import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepThreeLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepThreeLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.climbStepThreeLevels.data.climbStepThreeLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
